import { initExtensionCategories } from '@/views/pages/campaign/edit/index';

function funcSetCondition1(listCategoriesSub, listCategories, listDataMasterCampaignTypeChild, form) {
    // listCategoriesSub = []
    let filteredObjects = listCategoriesSub.filter((item) => !listCategories.includes(item.category_id));
    if (filteredObjects.length > 0) {
        filteredObjects.forEach((item) => {
            let index = listCategoriesSub.findIndex((x) => {
                return x.category_id == item.category_id;
            });

            if (index >= 0) {
                listCategoriesSub.splice(index, 1);
            }
        });
    } else {
        listCategories.forEach((item) => {
            let index = listDataMasterCampaignTypeChild.findIndex((x) => {
                return x.id == item;
            });
            let check = listDataMasterCampaignTypeChild.findIndex((x) => {
                return x.id == item && (x.value == 'X' || x.value == 'Instagram' || x.value == 'LINE' || x.value == 'TikTok');
            });
            let i = listCategoriesSub.findIndex((x) => {
                return x.category_id == item;
            });
            if (index >= 0 && i < 0) {
                const categoryValue = listDataMasterCampaignTypeChild.find((typeName) => typeName.id == item)?.value;
                const campaignTypeKey = form.campaign_type.value === 'オープン' ? 'open' : 'closed';
                const categoryName = categoryValue === 'はがき' ? 'ハガキ' : categoryValue;
                const defaultText = DEFAULT_APPLICATION_METHODS[campaignTypeKey]?.[categoryName];

                let obj = {
                    category_id: item,
                    category_value: categoryValue,
                    application_condition_1: null,
                    application_condition_2: [],
                    listCondition1: listDataMasterCampaignTypeChild[index].data,
                    listCondition2: [],
                    configHashTag: {
                        arrayTag: item.hashtag ?? []
                    },
                    extension: {
                        ...initExtensionCategories(),
                        application_method: defaultText ?? ''
                    },
                    checkSNS: check
                };
                listCategoriesSub.push(obj);
                listCategoriesSub = listCategoriesSub.sort((subA, subB) => subA.category_id - subB.category_id);
            }
        });
    }

    return {
        listCategoriesSub,
        listCategories,
        listDataMasterCampaignTypeChild,
        form
    };
}

function funcOrderLv1(
    itemLv1,
    listChecked,
    listOrderFilterLv1,
    listOrderFilterLv2,
    listOrderFilterLv3,
    listOrderFilterLv4,
    listRadio,
    contact_informations,
    contentOther
) {
    if (listChecked.msOrderLv1.includes(itemLv1.id)) {
        listOrderFilterLv1.push(itemLv1);
        listOrderFilterLv1 = listOrderFilterLv1.sort((aLv1, bLv1) => aLv1.order_index - bLv1.order_index);
    } else {
        listOrderFilterLv1 = listOrderFilterLv1.filter((item) => item.id !== itemLv1.id);
        itemLv1.data.forEach((lv1) => {
            listChecked.msOrderLv2 = listChecked.msOrderLv2.filter((itemLv2) => lv1.id !== itemLv2);
            listOrderFilterLv2 = listOrderFilterLv2.filter((orderFl2) => orderFl2.id !== lv1.id);
            contentOther = handleAssignContentOther(lv1, contentOther);
            if (funcOptionOneFilterLv2(lv1)) {
                listRadio.msOrderLv2[lv1.id] = '';
            }
            lv1.data.forEach((lv2) => {
                contentOther = handleAssignContentOther(lv2, contentOther);
                if (funcOptionOneFilterLv3(lv2)) {
                    listRadio.msOrderLv4[lv2.id] = '';
                }
                listChecked.msOrderLv3 = listChecked.msOrderLv3.filter((itemLv3) => lv2.id !== itemLv3);
                listOrderFilterLv3 = listOrderFilterLv3.filter((orderFl3) => orderFl3.id !== lv2.id);
                lv2.data.forEach((lv3) => {
                    contentOther = handleAssignContentOther(lv3, contentOther);
                    if (funcOptionOneFilterLv3(lv3)) {
                        listRadio.msOrderLv4[lv3.id] = '';
                    }
                    listChecked.msOrderLv4 = listChecked.msOrderLv4.filter((itemLv4) => lv3.id !== itemLv4);
                    listOrderFilterLv4 = listOrderFilterLv4.filter((orderFl4) => orderFl4.id !== lv3.id);
                    contact_informations[lv3.id] = '';
                });
            });
        });
    }
    return {
        listChecked,
        listOrderFilterLv1,
        listOrderFilterLv2,
        listOrderFilterLv3,
        listOrderFilterLv4,
        listRadio,
        contact_informations,
        contentOther
    };
}

function funcOrderLv2(
    itemLv2,
    listChecked,
    listOrderFilterLv2,
    listOrderFilterLv3,
    listOrderFilterLv4,
    listRadio,
    contact_informations,
    contentOther
) {
    if (listChecked.msOrderLv2.includes(itemLv2.id)) {
        listOrderFilterLv2.push(itemLv2);
        listOrderFilterLv2 = listOrderFilterLv2.sort((aLv2, bLv2) => aLv2.order_index - bLv2.order_index);
    } else {
        listOrderFilterLv2 = listOrderFilterLv2.filter((item) => item.id !== itemLv2.id);
        contentOther = handleAssignContentOther(itemLv2, contentOther);
        if (funcOptionOneFilterLv2(itemLv2)) {
            listRadio.msOrderLv2[itemLv2.id] = '';
        }
        itemLv2.data.forEach((lv2) => {
            contentOther = handleAssignContentOther(lv2, contentOther);
            if (funcOptionOneFilterLv3(lv2)) {
                listRadio.msOrderLv4[lv2.id] = '';
            }
            listChecked.msOrderLv3 = listChecked.msOrderLv3.filter((itemLv3) => lv2.id !== itemLv3);
            listOrderFilterLv3 = listOrderFilterLv3.filter((orderFl3) => orderFl3.id !== lv2.id);
            lv2.data.forEach((lv3) => {
                contentOther = handleAssignContentOther(lv3, contentOther);
                listChecked.msOrderLv4 = listChecked.msOrderLv4.filter((itemLv4) => lv3.id !== itemLv4);
                listOrderFilterLv4 = listOrderFilterLv4.filter((orderFl4) => orderFl4.id !== lv3.id);
                contact_informations[lv3.id] = '';
            });
        });
    }
    return {
        listChecked,
        listOrderFilterLv2,
        listOrderFilterLv3,
        listOrderFilterLv4,
        listRadio,
        contact_informations,
        contentOther
    };
}

function funcOrderLv3(itemLv3, listChecked, listOrderFilterLv3, listOrderFilterLv4, listRadio, contact_informations, contentOther) {
    if (listChecked.msOrderLv3.includes(itemLv3.id)) {
        listOrderFilterLv3.push(itemLv3);
        listOrderFilterLv3 = listOrderFilterLv3.sort((aLv3, bLv3) => aLv3.order_index - bLv3.order_index);
    } else {
        listOrderFilterLv3 = listOrderFilterLv3.filter((item) => item.id !== itemLv3.id);
        contentOther = handleAssignContentOther(itemLv3, contentOther);
        if (funcOptionOneFilterLv3(itemLv3)) {
            listRadio.msOrderLv4[itemLv3.id] = '';
        }
        itemLv3?.data?.forEach((lv3) => {
            contentOther = handleAssignContentOther(lv3, contentOther);
            listChecked.msOrderLv4 = listChecked.msOrderLv4.filter((itemLv4) => lv3.id !== itemLv4);
            listOrderFilterLv4 = listOrderFilterLv4.filter((orderFl4) => orderFl4.id !== lv3.id);
            contact_informations[lv3.id] = '';
        });
    }

    return {
        listChecked,
        listOrderFilterLv3,
        listOrderFilterLv4,
        listRadio,
        contact_informations,
        contentOther
    };
}

function funcOrderLv4(itemLv4, listChecked, listOrderFilterLv4, contact_informations, contentOther) {
    if (listChecked.msOrderLv4.includes(itemLv4.id)) {
        listOrderFilterLv4.push(itemLv4);
        listOrderFilterLv4 = listOrderFilterLv4.sort((aLv4, bLv4) => aLv4.order_index - bLv4.order_index);
    } else {
        listOrderFilterLv4 = listOrderFilterLv4.filter((item) => item.id !== itemLv4.id);
        contentOther = handleAssignContentOther(itemLv4, contentOther);
        contact_informations[itemLv4.id] = '';
    }

    return {
        listChecked,
        listOrderFilterLv4,
        contact_informations,
        contentOther
    };
}

function funcOptionOneFilterLv2(itemFilterLv2) {
    return (
        itemFilterLv2.value == '電話' ||
        itemFilterLv2.value == 'メール' ||
        itemFilterLv2.value == 'はがき回収' ||
        itemFilterLv2.value == 'WEBフォーム' ||
        itemFilterLv2.value == '応募数報告' ||
        itemFilterLv2.value == 'お問い合わせ報告' ||
        itemFilterLv2.value == '現物' ||
        itemFilterLv2.value == '当選者用フォーム'
    );
}

function funcOptionOneFilterLv3(itemFilterLv3) {
    return itemFilterLv3.value == '応募数報告' || itemFilterLv3.value == 'お問い合わせ報告' || itemFilterLv3.value == '現物';
}

function funcMapDataRegisted(
    form,
    listChecked,
    listRadio,
    listOrderFilterLv1,
    listOrderFilterLv2,
    listOrderFilterLv3,
    listOrderFilterLv4,
    contentOther
) {
    if (form.campaign_master_order_scopes && form.campaign_master_order_scopes.length > 0) {
        form.campaign_master_order_scopes.forEach((itemLv1) => {
            const idLargeItem = itemLv1.large_item?.id ?? itemLv1.large_item;
            if (!listChecked.msOrderLv1.includes(idLargeItem)) {
                contentOther[idLargeItem] = mapTextareaScope(itemLv1);
                listChecked.msOrderLv1.push(idLargeItem);
                listOrderFilterLv1 = listOrderFilterLv1.sort((aLv1, bLv1) => aLv1.order_index - bLv1.order_index);
            }
            if (itemLv1.medium_items && itemLv1.medium_items.length > 0) {
                itemLv1.medium_items.forEach((itemLv2) => {
                    const idMediumItem = itemLv2.medium_item?.id ?? itemLv2.medium_item;

                    if (!listChecked.msOrderLv2.includes(idMediumItem)) {
                        contentOther[idMediumItem] = mapTextareaScope(itemLv2);
                        listChecked.msOrderLv2.push(idMediumItem);
                        listOrderFilterLv2 = listOrderFilterLv2.sort((aLv2, bLv2) => aLv2.order_index - bLv2.order_index);
                    }
                    listRadio.msOrderLv2[idLargeItem] = idMediumItem;
                    if (itemLv2.small_items && itemLv2.small_items.length > 0) {
                        itemLv2.small_items.forEach((itemLv3) => {
                            const idSmallItem = itemLv3.small_item?.id ?? itemLv3.small_item;

                            if (!listChecked.msOrderLv3.includes(idSmallItem)) {
                                contentOther[idSmallItem] = mapTextareaScope(itemLv3);
                                listChecked.msOrderLv3.push(idSmallItem);
                                listOrderFilterLv3 = listOrderFilterLv3.sort((aLv3, bLv3) => aLv3.order_index - bLv3.order_index);
                            }
                            listRadio.msOrderLv2[idMediumItem] = idSmallItem;
                            if (itemLv3.detail_items && itemLv3.detail_items.length > 0) {
                                itemLv3.detail_items.forEach((itemLv4) => {
                                    const idDetailItem = itemLv4.detail_item?.id ?? itemLv4;
                                    if (!listChecked.msOrderLv4.includes(idDetailItem)) {
                                        contentOther[idDetailItem] = mapTextareaScope(itemLv4);
                                        listChecked.msOrderLv4.push(idDetailItem);
                                        listOrderFilterLv4 = listOrderFilterLv4.sort((aLv4, bLv4) => aLv4.order_index - bLv4.order_index);
                                    }
                                    listRadio.msOrderLv4[idSmallItem] = idDetailItem;
                                });
                            }
                        });
                    }
                });
            }
        });
    }
}

function handleAssignContentOther(alLv, newContent) {
    if (['その他（指定なし含む）', 'その他', '条件付き抽選'].includes(alLv.value)) newContent[alLv.id] = '';
    return newContent;
}

function mapTextareaScope(itemLevel) {
    return ['条件付き抽選'].includes(itemLevel?.value) ? itemLevel?.extension?.conditional_lottery : itemLevel?.extension?.content_other ?? '';
}

function parseJapaneseDate(str) {
    if (typeof str !== 'string') return null;
    const match = str.match(/^(?:(\d+)年)?(?:(\d+)月)?$/);
    if (!match) return null;
    return {
        year: parseInt(match[1], 10),
        month: parseInt(match[2], 10)
    };
}

function createYearArray(start, end) {
    const years = [''];
    for (let year = start; year <= end; year++) {
        years.push(year);
    }
    return years;
}

const LIST_SHIPPING_RANGER_DATE = [
    { id: 1, value: '上旬頃' },
    { id: 2, value: '中旬頃' },
    { id: 3, value: '下旬頃' }
];

const DEFAULT_APPLICATION_METHODS = {
    open: {
        WEB: '※下記編集してください※（編集後この文言削除）\n\nステップ1：キャンペーンサイトにアクセスしてください。\nステップ2：応募ボタンから応募フォーム にお進みいただき、必要事項をご入力の上、送信してください。',
        LINE: '※下記編集してください※（編集後この文言削除）\n\nステップ1：LINE公式アカウント●●を友だち追加してください。\nステップ2：LINE公式アカウント●●の【トークルームに送信されたメッセージに記載のURL / 下部メニューの応募ボタン】をタップして必要事項をご入力の上、「入力完了」ボタンをタップしてください。',
        ハガキ: '※下記編集してください※（編集後この文言削除）\n\nステップ1：ハガキに必要事項をご記入の上、事務局宛にご郵送ください。',
        X: '※下記編集してください※（編集後この文言削除）\n\nステップ1：●●公式Xアカウント「@●●」をフォローしてください。\nステップ2：公式Xアカウントのキャンペーン告知ポストをリポストしてください。（リポストキャンペーン）\nステップ2：キャンペーン指定のハッシュタグ（#●●）をつけて、「@●●」をメンションし、「●●」について投稿してください。（ハッシュタグキャンペーン）',
        Instagram:
            '※下記編集してください※（編集後この文言削除）\n\nステップ1：●●公式Instagramアカウント「@●●」をフォローしてください。\nステップ2：キャンペーン指定のハッシュタグ（#●●）をつけて、「@●●」をメンションし、「●●」について投稿してください。（ハッシュタグキャンペーン）\nステップ2：公式Instagramアカウントのキャンペーン告知投稿にコメントをしてください。（コメントキャンペーン）',
        TikTok: '※下記編集してください※（編集後この文言削除）\n\nステップ1：ご自身のTikTokアカウントを公開設定にし、公式TikTokアカウント（@●●）をフォローしてください。\nステップ2：公式TikTokアカウントのキャンペーン告知ポストをリポストしてください。（リポストキャンペーン）\nステップ2：キャンペーン指定のハッシュタグ（#●●）をつけて、「●●」について投稿してください。（ハッシュタグキャンペーン）'
    },
    closed: {
        WEB: '※下記編集してください※（編集後この文言削除）\n\nステップ1：応募条件を満たす購買証明（レシートなど）をご用意ください。\nステップ2：キャンペーンサイトの応募ボタンから、応募フォームにお進みいただき、必要事項をご入力の上、購買証明（レシートなど）の画像をアップロードしてください。\n※ファイル形式はjpeg・pngのみ、画像ファイル容量は1枚あたり最大●●MB以下で登録してください。',
        LINE: '※下記編集してください※（編集後この文言削除）\n\nステップ1：応募条件を満たす購買証明（レシートなど）をご用意ください。\nステップ2：LINE公式アカウント●●を友だち追加してください。\nステップ3：LINE公式アカウント●●の下部メニューから「応募する」ボタンをタップしてください。\nステップ4：LINE公式アカウント●●のトークルームに送信されたメッセージにからアンケートにご回答の上、「入力完了」ボタンをタップしてください。\nステップ5：トークルームに戻り、再度下部メニューから「応募する」ボタンをタップしてください。\nステップ6：画面の案内に沿って、ご希望賞品の選択、購買証明（レシートなど）の画像を送信してください。',
        ハガキ: '※下記編集してください※（編集後この文言削除）\n\nステップ1：応募条件を満たすレシートをご用意ください。\nステップ2：ハガキに必要事項をご記入の上、レシートを貼付け、事務局宛にご郵送ください。'
    }
};

export {
    funcSetCondition1,
    funcOrderLv1,
    funcOrderLv2,
    funcOrderLv3,
    funcOrderLv4,
    funcOptionOneFilterLv2,
    funcOptionOneFilterLv3,
    funcMapDataRegisted,
    parseJapaneseDate,
    createYearArray,
    LIST_SHIPPING_RANGER_DATE,
    DEFAULT_APPLICATION_METHODS
};
